// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseInstructorProfile-module--wrapper--3GcTO"};